<template>
  <div
    @mouseenter="isHovering = true"
    @mouseleave="isHovering = false"
    class="h-full"
  >
    <div class="absolute inset-0 overflow-hidden bg-white z-0 rounded">
      <img
        class="w-full h-full object-cover"
        :src="item.logo || require('@/assets/icons/nftnologo.avif')"
        alt=""
      />

      <div
        class="
          bg-background-70
          backdrop-filter backdrop-blur-lg
          w-full
          h-full
          absolute
          top-0
          left-0
        "
      ></div>
    </div>
    <div
      @click="$router.push(`/dao/${item.daoPath}/DAOPage`)"
      v-if="isHovering"
      style="
        z-index: 12;
        background: rgba(18, 20, 22, 0.7);
        border-radius: 0px 0px 8px 8px;
      "
      class="w-full absolute bottom-0 flex justify-center py-2"
    >
      <div class="text-xs font-bold">DAO Page</div>
      <span class="icon iconfont icon-right"></span>
    </div>
    <div
      class="
        flex flex-col
        h-full
        justify-center
        relative
        z-10
        text-center
        px-6
        rounded
      "
    >
      <div
        class="
          flex flex-col
          gap-2
          items-center
          justify-center
          w-full
          h-full
          rounded
        "
      >
        <UiImg
          class="w-14 h-14 rounded-full overflow-hidden"
          :src="item.logo || require('@/assets/icons/nftnologo.avif')"
        ></UiImg>
        <div>
          {{ item.name }}
        </div>
        <div
          :class="{
            'bg-inputActive': role.toLowerCase() === 'administrator',
            'bg-secondary-7': role.toLowerCase() !== 'administrator',
          }"
          class="text-xs px-2 rounded"
          v-for="(role, i) in item.role"
          :key="i"
        >
          {{ role }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import UiImg from '@/components/UiImg.vue';
import { ref } from 'vue';
const isHovering = ref(false);
const props = defineProps({ item: Object });
</script>
<style></style>
